import React, { Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Loader } from '@components/UI'
import Classroom from '@components/Classroom'
import Recording from '@components/Recording'
import Sketchpad from '@components/ClassroomSketchpad'

export const Main = () => {
  return (
    <Suspense fallback={<Loader icon dark full />}>
      <Switch>
        <Route exact path='/sketchpad/:id?' component={Sketchpad} />

        <Route exact path='/recording/:recordingId' component={Recording} />

        <Route exact path='/session/:id' component={Classroom} />

        <Route exact path='/demo' component={Classroom} />

        <Redirect to='/' />
      </Switch>
    </Suspense>
  )
}
